import { createModel } from '@/store/tools';

const model = {
    namespace: 'accountflow',
    build: (T, A, S, R) => ({
        actiontypes: {
            'getPayTypeList': T('getPayTypeList'),
            'getIncomeDrawTypeList': T('getIncomeDrawTypeList'),
            'getChangeSourceTypeList': T('getChangeSourceTypeList'),
            'getAccountList': T('getAccountList'),
            'getTransactionFlowList': T('getTransactionFlowList'),
        },
        actions: {
            'getPayTypeList': A('getPayTypeList'),
            'getIncomeDrawTypeList': A('getIncomeDrawTypeList'),
            'getChangeSourceTypeList': A('getChangeSourceTypeList'),
            'getAccountList': A('getAccountList'),
            'getTransactionFlowList': A('getTransactionFlowList'),
        },
        sagas: {
            'getPayTypeList': S('getPayTypeList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getIncomeDrawTypeList': S('getIncomeDrawTypeList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getChangeSourceTypeList': S('getChangeSourceTypeList', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getAccountList': S('getAccountList', '/?cmd=com.xqxc.api.pig.mis.settle.SettleAccountDetailApiMisService.serviceAccount'),
            'getTransactionFlowList': S('getTransactionFlowList', '/ad/list'),
        },
        reducers: {
            'payTypeList': R('getPayTypeList', []),
            'incomeDrawTypeList': R('getIncomeDrawTypeList', []),
            'changeSourceTypeList': R('getChangeSourceTypeList', []),
            'accountList': R('getAccountList', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
            'transactionFlowList': R('getTransactionFlowList', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
        }
    })
};
export default createModel(model);